// Adım 2 — sayaç + durum filtre çipleri + toplu kabul/atla + arama/kategori satırı
// (ImportMappingStep.tsx'ten ayrıldı — kırılım işi 2026-10-31, 600 satır sınırı; salt taşıma,
// davranış birebir). Durum ve kararlar ImportMappingStep'te kalır; buraya yalnız prop gelir.

import { KPI_IMPORT_COPY } from "../../../lib/kpi-import-copy";
import {
  type CategoryIndex,
  type MappingCounts,
  type MappingFilter,
  type MappingStatusFilter,
} from "../../../lib/kpi-import-wizard";
import { btnSmall, inputStyle, pillStyle } from "../kpi-form-styles";
import { chip } from "./ImportMappingPanels";

const m = KPI_IMPORT_COPY.mapping;

const STATUS_FILTERS: readonly MappingStatusFilter[] = [
  "pending",
  "unmatched",
  "uncertain",
  "matched",
  "skipped",
  "all",
];

export function ImportMappingToolbar(p: {
  counts: MappingCounts;
  filter: MappingFilter;
  categories: CategoryIndex["categories"];
  selectedCount: number;
  onFilter: (patch: Partial<MappingFilter>) => void;
  onAcceptHigh: () => void;
  onSkipSelected: () => void;
}): JSX.Element {
  const { counts, filter, categories, selectedCount, onFilter } = p;
  const filterLabel = (s: MappingStatusFilter): string => {
    const n = s === "all" ? counts.total : counts[s];
    return `${m.filters[s]} (${n.toString()})`;
  };
  return (
    <>
      {/* Sayaç + filtre çipleri + toplu işlemler */}
      <div className="flex items-center gap-2 flex-wrap">
        <span style={{ ...pillStyle, padding: "6px 12px", fontSize: "0.8rem" }} aria-live="polite">
          {m.counter(counts.matched, counts.total, counts.pending)}
        </span>
        {STATUS_FILTERS.map((s) => (
          <button
            key={s}
            type="button"
            style={chip(filter.status === s)}
            aria-pressed={filter.status === s}
            onClick={() => onFilter({ status: s })}
          >
            {filterLabel(s)}
          </button>
        ))}
        <span style={{ flex: 1 }} />
        <button
          type="button"
          style={btnSmall}
          disabled={counts.highConfidence === 0}
          onClick={p.onAcceptHigh}
        >
          {m.acceptHigh(counts.highConfidence)}
        </button>
        <button
          type="button"
          style={btnSmall}
          disabled={selectedCount === 0}
          onClick={p.onSkipSelected}
        >
          {m.skipSelected(selectedCount)}
        </button>
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        <input
          type="search"
          aria-label={m.search}
          placeholder={m.search}
          style={{ ...inputStyle, width: 320, minHeight: 36 }}
          value={filter.search}
          onChange={(e) => onFilter({ search: e.target.value })}
        />
        {categories.length > 0 ? (
          <select
            aria-label={m.categoryAll}
            style={{ ...inputStyle, width: 240, minHeight: 36 }}
            value={filter.category ?? ""}
            onChange={(e) => onFilter({ category: e.target.value || null })}
          >
            <option value="">{m.categoryAll}</option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>
                {c.label}
              </option>
            ))}
          </select>
        ) : null}
      </div>
    </>
  );
}
